import { RolesUsuario } from "./../../../../shared/enumeraciones/roles-usuario.enum";
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from "@angular/core";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { UsuarioRolService } from "../../containers/bandeja-principal/administrador/configuracion/usuario-rol/usuario-rol.service";
// tslint:disable-next-line:max-line-length
import { EstablecimientoComercioService } from "../../containers/bandeja-principal/prestador/establecimiento-comercio/establecimiento-comercio.service";
import { CamaraComercioEntry } from "src/app/shared/entrys/camara-comercio";
import { AuthService } from "src/app/shared/services/auth.service";

@Component({
  selector: "app-modal-seleccion-funcionario",
  templateUrl: "./modal-seleccion-funcionario.component.html",
  styleUrls: ["./modal-seleccion-funcionario.component.scss"],
})
export class ModalSeleccionFuncionarioComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  headerUsuarios: Array<string>;
  usuarioSeleccionado: any;
  filtro: FormGroup;
  modalGenerico: ModalGenericoModel;
  paginaActual: number;
  public isCollapsed = true;
  tipoUsuario: Array<any> = [];
  camarasLista: Array<CamaraComercioEntry>;
  camaraComercio: string;
  adminSuper = RolesUsuario.AdministradorSuper;
  adminCC = RolesUsuario.AdministradorCC;
  // @Input()
  // codigo_camara_shared: any;
  // @Input()
  // desc_camara_shared: any;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private usuarioRolService: UsuarioRolService,
    private usuarioService: UsuarioRolService,
    private establecimientoComercioService: EstablecimientoComercioService,
    public authService: AuthService
  ) {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;

    this.formulario();
    this.usuarioSeleccionado = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.modalGenerico = {
      titulo: "Seleccionar Usuario",
    };
    this.headerUsuarios = [
      "",
      "Número identificación",
      "Tipo de usuario",
      "Usuario",
      "Nombre Funcionario",
      "Correo electrónico",
      "Fecha de creación",
      "Estado",
    ];
    this.onCamaraSelect();
    this.onConsultarUsuario(1);
    this.usuarioService.getTipoUsuario().subscribe((resultado) => {
      if (resultado.data) {
        this.tipoUsuario = resultado.data;
      }
    });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarUsuario(value);
  }

  onCamaraSelect() {
    this.establecimientoComercioService.getCamaras().subscribe((resultado) => {
      if (resultado) {
        this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
        if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
          this.filtro
            .get("codigo_camara")
            .patchValue(this.authService.getCamaraUser());
          this.camaraComercio = this.camarasLista.find(
            (x) => x.codigo_camara === this.authService.getCamaraUser()
          ).desc_camara;
        }
      }
    });
  }

  onConsultarUsuario(page: number) {
    this.usuarioRolService
      .getFuncionariosReporte({
        ...this.filtro.value,
        tipo_usuario_id: RolesUsuario.Funcionario,
        numeroPagina: page,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  formulario() {
    this.filtro = this.formBuilder.group({
      codigo_camara: [null],
      numero_identificacion: [null],
      tipo_usuario_id: [null],
      usuario: [null],
      nombre_funcionarios: [null],
      correo_electronico: [null],
      activo: [null],
    });
  }

  selection(value) {
    this.usuarioSeleccionado = value;
  }

  confirm(): void {
    if (this.activeModal && this.usuarioSeleccionado) {
      this.activeModal.close(this.usuarioSeleccionado);
    }
  }

  dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }

  filtrar() {
    this.paginaActual = 1;
    this.onConsultarUsuario(1);
  }

  limpiar() {
    this.filtro.reset();
    this.filtrar();
  }
}
